import { Event, Emitter } from '@vscode-alt/monaco-editor/esm/vs/base/common/event';

import { IEditorModel } from '@vscode-alt/monaco-editor/esm/vs/platform/editor/common/editor';
import { Disposable } from '@workbench-stack/core';



export interface IModeSupport {

	/**
	 * Sets the language mode of the input.
	 */
	setMode(mode: string): void;
}


/**
 * The editor model is the heavyweight counterpart of editor input. Depneding on the editor input, it
 * connects to the disk to retrieve content and may allow for saving it back or reverting it. Editor models
 * are typically cached for some while because they are expensive to construct.
 */
export class EditorModel extends Disposable implements IEditorModel {
	isDisposed(): boolean {
		throw new Error("Method not implemented.");
	}

    private readonly _onDispose: Emitter<void> = this._register(new Emitter<void>());
	get onDispose(): Event<void> { return this._onDispose.event; }

	/**
	 * Causes this model to load returning a promise when loading is completed.
	 */
	load(): Promise<IEditorModel> {
		return Promise.resolve(this);
	}

	/**
	 * Returns whether this model was loaded or not.
	 */
	isResolved(): boolean {
		return true;
	}

	/**
	 * Subclasses should implement to free resources that have been claimed through loading.
	 */
	dispose(): void {
		this._onDispose.fire();

		super.dispose();
	}
}